import { useStore } from "vuex";

const languageJson = {
    'About US': 'Perrysについて',
    'Opening Hours': '営業時間',
    'Reservation Consultation': '予約',
    'Menu': 'メニュー',
    'Party Information': 'パーティー情報',
    'Contact US': '連絡先',
    'Diverse Social and Party Space': '多様な社交空間とパーティー空間',
    'Perrys Tokyo is a new style of social space and party venue with diverse entertainment ingredient. In the relaxed daytime, you can enjoy afternoon tea, Cake, Beer, Cocktails,Whisky and and Japanese local food.': 'Perrys Tokyoは、多様なエンターテインメント要素を備えた新しいソーシャルスペースとパーティ会場です。リラックスした昼間には、アフタヌーンティー、ケーキ、ビール、カクテル、ウイスキー、日本のご当地グルメを楽しむことができます。',
    'In the sensational nighttime, the light and shadow design with classic music will create a unique immersive atmosphere for your body and soul relax space.': 'センセーショナルな夜には、クラシック音楽の光と影のデザインが、心身のリラックス空間に独特の没入的な雰囲気を醸し出します。',
    '14:00-18:00 Afternoon Tea, Coffee': '14：00-18：00　ティータイム',
    '19:00-23:00 Whisky, Cocktail': '19:00-23:00ウイスキー、カクテル',
    '23:00-04:00 Party Time': '23：00-04：00パーティータイム',
    'Table Available': '席数',
    'Reservation Consultation ': '予約コンサルティング',
    '派 Perrys': '派 Perrys',
    'Cocktail': 'カクテル',
    'Whisky': 'ウイスキー',
    'Cigar': 'シガー',
    'Party': 'パーティー',
    'Menu Content': 'メニュー',
    'Afternoon Tea | Coffee': 'アフタヌーンティー｜コーヒー｜軽食',
    'Daytime 14:00-18:00': '日中14:00-18:00',
    'Whisky | Cocktail | Party ': 'ウイスキー｜カクテル｜パーティー',
    'Party Information ': 'パーティーインフォメーション',
    'Contact Information': '連絡先',
    'Brand Cooperation': 'ブランド提携',
    'Business Cooperation': 'ビジネス提携',
    'Recruitment Contact': '採用担当者',
    'Supply Chain': 'サプライチェーン',
}

//0 默认可以转换日文，1英文
export const Getlanguage = function (str, replaceConfig) {
    let result = str
    if (languageJson[str]) {
        const store = useStore();
        let transferable = '0'
        if (store){
            transferable = store.state.isTransferTextStatus
        }
        if (transferable == '0') {
            result = languageJson[str]
        }
    } else { // 这里如果没有配置多语言的打个日志出来，避免漏翻译的情况
        console.log('找不到 ' + str)
        return str;
    }
    if (replaceConfig){
        Object.keys(replaceConfig).forEach(function(key){
            result = result.replace(key, replaceConfig[key])
        })
        return result
    } else {
        return result
    }
};
export default Getlanguage
